"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-comment-textnodes */

var fadeOut = (0, _styledComponents.keyframes)(["0%{opacity:1;}100%{opacity:0;}"]);
var StyledDragSpinIcon = _styledComponents["default"].svg.withConfig({
  displayName: "DragSpin__StyledDragSpinIcon",
  componentId: "sc-73hufm-0"
})(["width:192px;height:auto;pointer-events:none;opacity:1;animation:", " 0.5s linear forwards;"], function (props) {
  return props.out ? fadeOut : null;
});
var DragSpin = function DragSpin(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-filename-extension
    _react["default"].createElement(StyledDragSpinIcon, {
      viewBox: "0 0 320 213",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      out: props.out
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M307.959 195.039a5.763 5.763 0 0 1-1.684 4.071 5.746 5.746 0 0 1-4.065 1.686H16.701a5.747 5.747 0 0 1-4.065-1.686 5.762 5.762 0 0 1-1.683-4.071V14.661a5.76 5.76 0 0 1 1.684-4.071A5.744 5.744 0 0 1 16.7 8.904H302.21c1.525 0 2.987.606 4.065 1.686a5.762 5.762 0 0 1 1.684 4.07V195.04Z",
      fill: "#000",
      fillOpacity: ".5"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m285.561 104.848-15.445-12.492v8.159H234.33v8.671h35.786v8.156l15.445-12.494Z",
      fill: "#fff"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      clipRule: "evenodd",
      d: "m285.561 104.848-15.445-12.492v8.159H234.33v8.671h35.786v8.156l15.445-12.494Z",
      stroke: "#fff",
      strokeWidth: ".355",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m34.359 104.852 15.444 12.49v-8.159H85.59v-8.672H49.803v-8.155L34.36 104.852Z",
      fill: "#fff"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      clipRule: "evenodd",
      d: "m34.359 104.852 15.444 12.49v-8.159H85.59v-8.672H49.803v-8.155L34.36 104.852Z",
      stroke: "#fff",
      strokeWidth: ".355",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M95.222 93.075h6.335c5.367 0 6.335 3.685 6.335 9.328 0 6.799-1.451 9.865-6.577 9.865h-6.093V93.075Zm3.865 16.346h1.717c2.684 0 3.221-1.695 3.221-6.912 0-4.353-.349-6.586-3.302-6.586h-1.636v13.498Zm11.238-11.616h3.543v1.938h.054c.751-1.398 1.797-2.314 3.328-2.314.215 0 .456.027.671.054v3.548c-.376-.025-.778-.052-1.154-.052-1.287 0-2.738.672-2.738 2.606v8.683h-3.704V97.805Zm8.905 4.437v-.351c0-3.333 2.282-4.462 5.072-4.462 4.403 0 5.235 1.83 5.235 4.435v7.608c0 1.342.08 1.96.456 2.796h-3.543c-.242-.456-.349-1.023-.456-1.506h-.054c-.86 1.506-1.907 1.88-3.677 1.88-2.577 0-3.489-2.202-3.489-4.137 0-2.717 1.099-3.818 3.65-4.517l2.092-.564c1.102-.297 1.478-.725 1.478-1.694 0-1.102-.483-1.773-1.719-1.773-1.125 0-1.717.752-1.717 1.88v.405h-3.328Zm6.764 2.796a4.571 4.571 0 0 1-1.583.723c-1.502.323-2.094 1.05-2.094 2.339 0 1.102.402 2.017 1.394 2.017.995 0 2.283-.645 2.283-2.23v-2.849Zm16.983-7.233v13.736c0 3.819-1.69 5.67-6.011 5.67-3.141 0-4.913-1.397-4.913-3.868h3.544c0 .483.215.86.564 1.103.349.24.778.401 1.234.401 1.502 0 2.041-1.128 2.041-2.606v-1.911h-.056c-.749 1.077-1.905 1.777-3.085 1.777-2.953 0-4.43-2.017-4.43-7.313 0-3.387.511-7.365 4.535-7.365 1.022 0 2.283.484 2.98 1.992h.056v-1.616h3.541Zm-5.555 11.454c1.556 0 2.014-1.694 2.014-4.143 0-3.519-.458-4.837-1.934-4.837-1.638 0-1.933 1.318-1.933 5.214 0 1.989.295 3.766 1.853 3.766Zm15.394-15.59h3.704v4.136h2.148v2.526h-2.148v7.821c0 1.132.243 1.591 1.315 1.591.295 0 .592-.031.833-.058v2.583c-.805.079-1.558.161-2.416.161-2.899 0-3.436-.888-3.436-3.818v-8.28h-1.88v-2.526h1.88v-4.137Zm12.342 3.76c4.459-.08 5.691 2.579 5.691 7.609 0 4.945-1.448 7.604-5.691 7.604-4.455.083-5.687-2.579-5.687-7.604 0-4.947 1.447-7.609 5.687-7.609Zm0 12.688c1.506 0 1.989-1.477 1.989-5.079 0-3.606-.483-5.081-1.989-5.081-1.824 0-1.985 2.124-1.985 5.081 0 2.953.161 5.079 1.985 5.079Zm17.328-3.845v.566c0 1.802.512 2.957 2.551 2.957 1.182 0 2.309-.754 2.309-2.366 0-1.746-.886-2.391-3.436-3.28-3.436-1.184-5.021-2.607-5.021-5.804 0-3.736 2.283-5.644 5.933-5.644 3.436 0 5.932 1.476 5.932 5.16v.535h-3.705c0-1.798-.616-2.847-2.093-2.847-1.746 0-2.2 1.101-2.2 2.23 0 1.184.349 1.907 1.985 2.609l2.98 1.288c2.897 1.264 3.65 2.744 3.65 5.083 0 4.055-2.47 5.883-6.654 5.883-4.377 0-6.094-2.041-6.094-5.591v-.779h3.863Zm10.704-8.467h3.543v1.534h.053c.805-1.347 1.825-1.91 3.275-1.91 3.033 0 4.43 2.232 4.43 7.609 0 5.375-1.397 7.604-4.43 7.604-1.395 0-2.336-.562-3.114-1.719h-.053v6.075h-3.704V97.805Zm5.662 11.99c1.612 0 1.934-1.612 1.934-4.757 0-3.147-.322-4.759-1.934-4.759-1.636 0-1.958 1.612-1.958 4.759 0 3.145.322 4.757 1.958 4.757Zm7.887-16.933h3.704v3.17h-3.704v-3.17Zm0 4.943h3.704v14.463h-3.704V97.805Zm6.302 0h3.541V99.5h.056c.778-1.426 2.119-2.07 3.675-2.07 2.311 0 3.679 1.264 3.679 4.112v10.726h-3.704v-9.972c0-1.451-.485-2.017-1.584-2.017-1.263 0-1.961.779-1.961 2.391v9.598h-3.702V97.805Z",
      fill: "#F9F8F4"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m159.458 174.462 12.472-15.468h-8.148v-35.836h-8.659v35.836h-8.143l12.478 15.468Z",
      fill: "#fff"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      clipRule: "evenodd",
      d: "m159.458 174.462 12.472-15.468h-8.148v-35.836h-8.659v35.836h-8.143l12.478 15.468Z",
      stroke: "#fff",
      strokeWidth: ".355",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M159.452 36.114 146.98 51.583h8.147V87.42h8.657V51.583h8.146l-12.478-15.469Z",
      fill: "#fff"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      clipRule: "evenodd",
      d: "M159.452 36.114 146.98 51.583h8.147V87.42h8.657V51.583h8.146l-12.478-15.469Z",
      stroke: "#fff",
      strokeWidth: ".355",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M143.507 79.345c-22.685-2.26-44.545-10.796-65.358-25.54l.358-.522 5.814-8.478-22.895 1.798 6.57 22.025 5.82-8.495c24.466 17.303 48.389 24.733 69.697 26.761l-.006-7.549",
      fill: "url(#paint0_linear_6526_22639)",
      fillOpacity: ".8"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M172.57 79.345c22.686-2.26 44.545-10.796 65.359-25.54l-.359-.522-5.813-8.478 22.894 1.798-6.569 22.025-5.821-8.495c-24.466 17.303-48.389 24.733-69.697 26.761l.006-7.549",
      fill: "url(#paint1_linear_6526_22639)",
      fillOpacity: ".7"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M145.314 130.36c-22.685 2.26-44.545 10.796-65.358 25.541l.358.522 5.814 8.477-22.895-1.798 6.57-22.025 5.82 8.495c24.466-17.303 48.389-24.733 69.697-26.761l-.006 7.549Z",
      fill: "url(#paint2_linear_6526_22639)",
      fillOpacity: ".5"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M174.379 130.36c22.685 2.26 44.545 10.796 65.358 25.541l-.358.522-5.814 8.477 22.895-1.798-6.569-22.025-5.821 8.495c-24.466-17.303-48.389-24.733-69.697-26.761l.006 7.549Z",
      fill: "url(#paint3_linear_6526_22639)",
      fillOpacity: ".7"
    }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
      id: "paint0_linear_6526_22639",
      x1: "143.513",
      y1: "86.661",
      x2: "51.98",
      y2: "86.661",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      stopColor: "#333",
      stopOpacity: ".472"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "1",
      stopColor: "#fff"
    })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
      id: "paint1_linear_6526_22639",
      x1: "172.564",
      y1: "86.661",
      x2: "264.098",
      y2: "86.661",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      stopColor: "#333",
      stopOpacity: ".472"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "1",
      stopColor: "#fff"
    })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
      id: "paint2_linear_6526_22639",
      x1: "145.32",
      y1: "123.044",
      x2: "53.787",
      y2: "123.044",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      stopColor: "#333",
      stopOpacity: ".472"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "1",
      stopColor: "#fff"
    })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
      id: "paint3_linear_6526_22639",
      x1: "174.373",
      y1: "123.044",
      x2: "265.906",
      y2: "123.044",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/_react["default"].createElement("stop", {
      stopColor: "#333",
      stopOpacity: ".472"
    }), /*#__PURE__*/_react["default"].createElement("stop", {
      offset: "1",
      stopColor: "#fff"
    }))))
  );
};
DragSpin.propTypes = {
  out: _propTypes["default"].bool.isRequired
};
var _default = DragSpin;
exports["default"] = _default;
//# sourceMappingURL=DragSpin.js.map